// src/pages/QuanLyHocSinh/QuanLyHocSinhMobile.js
import React from "react";

const STATUS_STYLE = {
  dangHoc: 'bg-green-100 text-green-700',
  nghiHoc: 'bg-red-100 text-red-700',
  chuyenLop: 'bg-blue-100 text-blue-700',
  luuBan: 'bg-yellow-100 text-yellow-700',
  totNghiep: 'bg-purple-100 text-purple-700'
};

const QuanLyHocSinhMobile = ({ filtered, getTenLop, getTenGiaoHo, onView, onEdit, onDelete, canEdit, canDelete }) => {
  if (filtered.length === 0) {
    return (
      <div className="text-center py-12 text-on-surface-variant">
        <span className="material-symbols-outlined text-[48px]">person_off</span>
        <p className="mt-2">Không tìm thấy học sinh</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {filtered.map(hs => {
        const initials = ((hs.tenThanh || '') + ' ' + (hs.hoTen || ''))
          .split(' ')
          .filter(w => w)
          .slice(0, 2)
          .map(w => w.charAt(0))
          .join('')
          .toUpperCase() || '?';

        return (
          <div 
            key={hs.id} 
            className="bg-surface-container-lowest p-4 rounded-xl border border-outline-variant/20 shadow-[0px_2px_8px_rgba(0,0,0,0.05)] flex items-center gap-4 transition-all active:bg-surface-container cursor-pointer"
            onClick={() => onView(hs)}
          >
            {/* Avatar */}
            <div className="w-12 h-12 rounded-full bg-primary-container flex items-center justify-center text-on-primary-container font-bold text-lg flex-shrink-0">
              {initials}
            </div>

            {/* Info */}
            <div className="flex-grow min-w-0">
              <div className="flex items-center gap-1">
                {hs.tenThanh && <span className="font-caption text-caption text-secondary">{hs.tenThanh}</span>}
                <h3 className="font-body-lg text-body-lg truncate text-on-surface">{hs.hoTen}</h3>
              </div>
              
              <div className="flex flex-wrap gap-x-3 gap-y-1 mt-0.5">
                <span className="flex items-center gap-1 font-caption text-caption text-on-surface-variant">
                  <span className="material-symbols-outlined text-[14px]">meeting_room</span> 
                  {getTenLop(hs.lopHienTaiId)}
                </span>
                {hs.giaoHoId && (
                  <span className="flex items-center gap-1 font-caption text-caption text-on-surface-variant">
                    <span className="material-symbols-outlined text-[14px]">location_city</span> 
                    {getTenGiaoHo(hs.giaoHoId)}
                  </span>
                )}
                <span className={`px-2 py-0.5 rounded-full text-label-caps ${STATUS_STYLE[hs.trangThai] || ''}`}>
                  {hs.trangThai === 'dangHoc' ? 'Đang học' : 
                   hs.trangThai === 'nghiHoc' ? 'Nghỉ học' : 
                   hs.trangThai === 'chuyenLop' ? 'Chuyển lớp' :
                   hs.trangThai === 'luuBan' ? 'Lưu ban' : 'Tốt nghiệp'}
                </span>
              </div>
            </div>

            {/* Actions */}
            <div className="flex-shrink-0 flex items-center gap-1" onClick={e => e.stopPropagation()}>
              {canEdit && (
                <button onClick={() => onEdit(hs)} className="p-2 hover:bg-surface-container rounded-full text-on-surface-variant transition-colors">
                  <span className="material-symbols-outlined text-[20px]">edit</span>
                </button>
              )}
              {canDelete && (
                <button onClick={() => onDelete(hs)} className="p-2 hover:bg-error-container rounded-full text-error transition-colors">
                  <span className="material-symbols-outlined text-[20px]">delete</span>
                </button>
              )}
              <span className="material-symbols-outlined text-outline text-[20px]">chevron_right</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default QuanLyHocSinhMobile;